import * as angular from 'angular';

import { ComponentDefinition, IUiConfiguration } from '../../../../models';
import { IConfigurationService, ILoggerService } from '../../../../services';
import { validateEmailList } from '../../../../common/helpers/validateEmailList';

class UiParametersController implements angular.IComponentController {
    configuration: IUiConfiguration;
    formController: angular.IFormController;
    isLoading: boolean;
    supportText: string;

    private _pristine: IUiConfiguration;

    static $inject = [
        '$window',
        'configurationService',
        'translatedLoggerService'
    ];

    constructor(
        private _$window: angular.IWindowService,
        private _configurationService: IConfigurationService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.isLoading = true;
        this._configurationService
            .getUiConfiguration()
            .then(config => {
                this._pristine = config;
                this.resetWorkingCopy();
            })
            .finally(() => this.isLoading = false);
    }

    cancel() {
        this.resetWorkingCopy();
    }

    save() {
        this.isLoading = true;
        if (!!this.supportText) {
            if (!this.configuration.supportDetails) {
                this.configuration.supportDetails = {
                    content: [],
                    email: null
                };
            }
            this.configuration.supportDetails.content = this.supportText.split('\n');
        }
        this._configurationService
            .setUiConfiguration(this.configuration)
            .then(config => {
                this._pristine = config;
                this.resetWorkingCopy();
                this._loggerService.logSuccess('Saved');
                this._$window.location.reload();

            }).catch(reason => {
                console.error(reason);
                this._loggerService.logError('Configuration has not been saved');
            })
            .finally(() => this.isLoading = false);
    }

    validateEmail(email: string): { [key: string]: any } {
        const isEmailValid = validateEmailList(email);
        this.formController.adminProperty.$setValidity('invalid', isEmailValid);
        return { 'invalid': !isEmailValid };
    }

    private resetWorkingCopy() {
        this.configuration = angular.copy(this._pristine); // Using angular.copy to have a deep copy
        this.supportText = this.configuration.supportDetails?.content.join('\n');
        this.formController?.$setPristine();
    }
}

export const wtUiParameters: ComponentDefinition = {
    componentId: 'wtUiParameters',
    controller: UiParametersController,
    template: require('./uiParameters.component.html'),
    controllerAs: 'vm',
    bindings: {}
};